import { CompanyFormValues } from "./companySettingsSchema"
import { CompanySettings } from "@/types"


/**
 * Get form default values from company settings
 */
export function getFormDefaultValues(settings: CompanySettings | null): Partial<CompanyFormValues> {
  const defaultValues: Partial<CompanyFormValues> = {
    companyName: "",
    maxOvertimeHours: "",
    weekStartDay: "monday"
  }
  
  try {
    if (!settings) {
      return defaultValues;
    }
    
    return {
      companyName: settings.companyName || "",
      maxOvertimeHours: settings.maxOvertimeHours?.toString() || "",
      weekStartDay: settings.weekStartDay || "monday"
    }
  } catch {

    return defaultValues
  }
}
